import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
import Swal from "sweetalert2";
const CreaTaller = () => {
  const [postNit, setPostNit] = useState([]);
  const [postSucursal, setPostSucursal] = useState([]);
  const [postNombre, setPostNombre] = useState([]);
  const [postDireccion, setPostDireccion] = useState([]);
  const [postTelefono, setPostTelefono] = useState([]);
  const [postNumCertificado, setPostNumCertificado] = useState([]);
  const [postEmitido, setPostEmitido] = useState([]);
  const [postFechaEmision, setPostFechaEmision] = useState([]);
  const [postFechaVencimiento, setPostFechaVencimiento] = useState([]);
  const [postPolizaResponsableCivil, setPostPolizaResponsableCivil] = useState(
    [],
  );
  const [postUltimaVigenciaPoliticaDL, setPostUltimaVigenciaPoliticaDL] =
    useState([]);
  const [postIdRomChipValidador, setPostIdRomChipValidador] = useState([]);
  const [postChipTanqueo, setPostChipTanqueo] = useState([]);
  const [postNumeroTecnicos, setPostNumeroTecnicos] = useState([]);
  const [postRegionalId, setPostRegionalId] = useState([]);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerRegional",
    })
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const postData = (e) => {
    e.preventDefault();

    // Validación manual de campos obligatorios
    const camposObligatorios = {
      NIT: postNit,
      Sucursal: postSucursal,
      "Nombre de la Sede": postNombre,
      Dirección: postDireccion,
      "Número de Certificado": postNumCertificado,
      Emitido: postEmitido,
      "Fecha Emisión": postFechaEmision,
      "Fecha Vencimiento": postFechaVencimiento,
      "Póliza Responsable Civil": postPolizaResponsableCivil,
      "Última Vigencia Política DL": postUltimaVigenciaPoliticaDL,
      Regional: selectedOptions?.value,
    };

    const faltantes = Object.entries(camposObligatorios)
      .filter(([_, valor]) => !valor || valor.toString().trim() === "")
      .map(([campo]) => campo);

    if (faltantes.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Campos obligatorios faltantes",
        html: `<ul style="text-align:left">
        ${faltantes.map((campo) => `<li>${campo}</li>`).join("")}
      </ul>`,
        confirmButtonText: "Entendido",
      });
      return;
    }

    // ✅ Si todo está completo, enviamos
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CreaTaller",
      data: {
        nit: postNit,
        sucursal: postSucursal,
        nombreTaller: postNombre,
        direccion: postDireccion,
        telefono: postTelefono, // opcional
        numeroCertificado: postNumCertificado,
        emitido: postEmitido,
        fechaEmision: postFechaEmision,
        fechaVencimiento: postFechaVencimiento,
        polizaResponsableCivil: postPolizaResponsableCivil,
        ultimaVigenciaPoliticaDL: postUltimaVigenciaPoliticaDL,
        idRomChipValidador: postIdRomChipValidador,
        chipTanqueo: postChipTanqueo,
        numeroTecnicos: postNumeroTecnicos,
        estado: "Activo",
        regionalId: selectedOptions.value,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        Swal.fire({
          icon: "success",
          title: "Taller creado con éxito",
          confirmButtonText: "Aceptar",
        }).then(() => {
          window.location.reload("/");
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error al crear",
          text: error.message || "Ocurrió un error inesperado",
        });
      });
  };

  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nuevo
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Taller</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <br></br> <br></br>
                  <Form>
                    <Row className="align-items-center">
                      <Col xs="8">
                        <h3 className="mb-0">Talleres</h3>
                      </Col>
                    </Row>

                    <CardBody>
                      <Form>
                        <h6 className="heading-small text-muted mb-4">
                          Creación de Taller
                        </h6>
                        <div className="pl-lg-4">
                          <Row>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-email"
                                >
                                  NIT
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) => setPostNit(e.target.value)}
                                />
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-email"
                                >
                                  Sucursal
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostSucursal(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Nombre de la Sede
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostNombre(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Dirección
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostDireccion(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Telefono
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostTelefono(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Numero de Certificado
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="email"
                                  required
                                  onChange={(e) =>
                                    setPostNumCertificado(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="3">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Emitido
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostEmitido(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Fecha Emisión
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="date"
                                  required
                                  onChange={(e) =>
                                    setPostFechaEmision(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Fecha Vencimiento
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="date"
                                  required
                                  onChange={(e) =>
                                    setPostFechaVencimiento(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Poliza responsabel civil
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostPolizaResponsableCivil(
                                      e.target.value,
                                    )
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Ultima vigencia Politica DL
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  required
                                  onChange={(e) =>
                                    setPostUltimaVigenciaPoliticaDL(
                                      e.target.value,
                                    )
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col lg="6">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Idrom chip validador
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  onChange={(e) =>
                                    setPostIdRomChipValidador(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col lg="4">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Chip Tanquep
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  onChange={(e) =>
                                    setPostChipTanqueo(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col lg="4">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-name"
                                >
                                  Numero de Tecnicos
                                </label>
                                <Input
                                  className="form-control-alternative"
                                  id="input-email"
                                  type="text"
                                  onChange={(e) =>
                                    setPostNumeroTecnicos(e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col lg="4">
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-country"
                                >
                                  Regional
                                </label>
                                <Select
                                  name="colors"
                                  options={options}
                                  classNamePrefix="select"
                                  onChange={(selected) =>
                                    setSelectedOptions(selected)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <hr className="my-4" />
                        <center>
                          <button
                            className="btn btn-primary btn-lg"
                            color="primary"
                            onClick={postData}
                          >
                            ENVIAR
                          </button>
                        </center>
                      </Form>
                    </CardBody>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CreaTaller;
